import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { ColDef, RowSelectedEvent } from 'ag-grid-community';
import { InputsResultSummaryPWC, ResultSummaryPWC } from '../eea-output-project-pwc/eea-output-project-pwc.interface.model';
import { EeaOutputProjectPwcResultsPondReservoirColDef } from './eea-output-project-pwc-results.coldef';
import { Constants } from 'src/app/shared/utils/constants';
import { EEAOutputProjectLogicService } from '../../eea-output-project.logic.service';
import { GridComponent } from 'src/app/shared/components/grid/grid.component';

@Component({
  selector: 'eea-output-project-pwc-grid',
  templateUrl: './eea-output-project-pwc-grid.component.html'
})
export class EeaOutputProjectPwcGridComponent implements OnInit {

  @ViewChild('grid') grid!: GridComponent;

  @Input() inputsRowData?: InputsResultSummaryPWC[];
  @Input() rawData?: ResultSummaryPWC[];
  @Input() waterbodies?: string;
  @Input({required: true}) isProjectOwnershipValid: boolean = false;

  public columnDefs: ColDef[] = [];
  public rowData: ResultSummaryPWC[] | InputsResultSummaryPWC[] = [];
  public useSelectAll: boolean = false;

  private columnsDefPondReservoir = inject(EeaOutputProjectPwcResultsPondReservoirColDef);
  private eeaOutputProjectlogicService = inject(EEAOutputProjectLogicService);


  public async ngOnInit(): Promise<void> {

    if(this.rawData){
      this.useSelectAll = true;
      switch(this.waterbodies){
        case Constants.WATERBODIES_USA.POND:
          this.rowData = this.rawData.filter(row => row.Waterbody === Constants.WATERBODIES_USA.POND || row.Waterbody === Constants.WATERBODIES_USA.RESERVOIR);
          this.columnDefs = this.columnsDefPondReservoir.getPondReservoirColumnsDefinition(this.isProjectOwnershipValid);
          break;

        case Constants.WATERBODIES_USA.TERRESTRIAL:
          this.rowData = this.rawData.filter(row => row.Waterbody === Constants.WATERBODIES_USA.TERRESTRIAL);
          this.columnDefs = this.columnsDefPondReservoir.getTpezColumnsDefinition(this.isProjectOwnershipValid);
          break;

        case Constants.WATERBODIES_USA.WETLAND:
          this.rowData = this.rawData.filter(row => row.Waterbody === Constants.WATERBODIES_USA.WETLAND);
          this.columnDefs = this.columnsDefPondReservoir.getWpezColumnsDefinition(this.isProjectOwnershipValid);
          break;
      }

      this.refreshSelectedValuesTimeout();
    }

    if(this.inputsRowData){
      this.rowData = this.inputsRowData;
      this.columnDefs = this.columnsDefPondReservoir.getInputsColumnsDefinition();
    }

  }

  public onSelectedRowEvent( event: RowSelectedEvent ){
    this.eeaOutputProjectlogicService.setSmeSelectionResultSummaryPwc( event );
  }

  private refreshSelectedValuesTimeout(): void {
    setTimeout(() => {
      this.refreshSelectedValues();
    }, 75);
  }

  private refreshSelectedValues(): void {
    if( !this.grid ) return;
    this.grid.refreshSelectedValues( 'EeaSmeSelection' );
  }

  public onSelectedAllChanged( ){
    if( !this.grid ) return;
    this.eeaOutputProjectlogicService.setSmeSelectionsResultSummaryPwc( this.grid );
  }

}
